import ApiService from '@/services/core/api.service'

const FacebookRawService = {
  async get (query) {
    return ApiService.get(`agent/facebook-raw?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/facebook-raw', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/facebook-raw/${payload.id}`, payload)
  }
}

export default FacebookRawService
